<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

/* eslint-disable */
const props = defineProps({
  typeItem: {
    type: String,
    default: 'dropdown',
    required: true,
  },
  toLink: {
    type: String,
    default: '/',
    required: true,
  },
  title: {
    type: String,
    default: '/',
    required: true,
  },
  isOpen: {
    type: Boolean,
    default: false,
    required: false,
  },
  childrenItems: {
    type: Array,
    default: [],
    required: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
    required: false,
  },
})
const emit = defineEmits([
  'update:isOpen',
])

const submenuRef = ref(null)

const updateOpen = () => {
  event.stopPropagation()
  emit('update:isOpen', !props.isOpen)
  console.log('props.isOpen', props.isOpen)
}

const handleClickOutside = (event) => {
  if (submenuRef.value && !submenuRef.value.contains(event.target)) {
    emit('update:isOpen', false) // Cerrar el menú si se hace clic fuera del <ul>
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
console.log('childrenItems:', props.isOpen)
</script>
<template>
  <li v-if="props.typeItem === 'dropdown'">
    <router-link
      :to="props.toLink"
      class="nav-link"
      @click.stop="updateOpen"
    >
      {{ props.title }}
      <span class="menu-arrow"></span>
    </router-link>
    <ul ref="submenuRef" class="submenu" :class="props.isOpen ? 'block' : 'hidden'">
      <li v-for="(item, index) in props.childrenItems" :key="index">
        <router-link :to="item.toLink" class="sub-menu-item">
          {{ item.title }}
        </router-link>
      </li>
    </ul>
  </li>
  <li
    v-else-if="props.typeItem === 'megamenu'"
    class="has-submenu parent-parent-menu-item product"
    :class="props.isMobile ? 'border-b-2': ''"
    @click.stop="updateOpen"
  >
    <router-link :to="props.toLink" class="nav-link">
      {{ props.title }} <span class="menu-arrow" :class="props.isMobile ? 'top-[20px]': ''"></span>
    </router-link>
    <ul ref="submenuRef" class="submenu megamenu block lg:flex overflow-hidden" :class="props.isOpen ? !props.isMobile  ? 'visible opacity-100' : 'h-full' : 'h-0'">
      <li v-for="(item, index) in props.childrenItems" :key="index">
        <ul v-if="item.subItems && item.subItems.length">
          <li
            v-for="(el, index1) in item.subItems"
            :key="index1"
            :class="el.head ? 'megamenu-head text-gray-500' : ''"
          >
            <router-link v-if="!el.head" :to="el.toLink" class="sub-menu-item">
              {{ el.title }}
            </router-link>
            <span v-else>{{ el.title }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </li>
  <li v-else>
    <router-link :to="props.toLink" class="sub-menu-item nav-link" :class="props.isMobile ? 'border-b-2': ''">
      {{ props.title }}
    </router-link>
  </li>
</template>
<style lang="scss" scoped></style>
